import { Phone, Mail, MapPin, Wrench } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL_DISPLAY, NAV_LINKS } from "@/lib/content";
import { scrollToId } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-slate-950 py-16 text-slate-400">
      <div className="mx-auto max-w-7xl px-6 sm:px-10">
        <div className="grid gap-12 md:grid-cols-[1.2fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-amber-500 text-slate-950">
                <Wrench className="h-5 w-5" />
              </span>
              <div className="leading-tight">
                <p className="font-display text-sm font-bold text-white">Atlantic Corridor</p>
                <p className="font-mono-accent text-[10px] uppercase tracking-[0.22em] text-slate-500">
                  Property Maintenance LLC
                </p>
              </div>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed">
              Owner-operated by Michael Caso. Prompt, professional handyman and
              property-maintenance services across South Florida's Atlantic corridor.
            </p>
          </div>

          <div>
            <p className="font-mono-accent mb-5 text-[11px] uppercase tracking-[0.2em] text-slate-500">
              Explore
            </p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollToId(l.id)}
                    className="text-sm transition-colors duration-200 hover:text-amber-500"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono-accent mb-5 text-[11px] uppercase tracking-[0.2em] text-slate-500">
              Contact Michael
            </p>
            <ul className="space-y-3.5 text-sm">
              <li>
                <a data-testid="footer-phone-link" href={PHONE_TEL} className="flex items-center gap-2.5 transition-colors duration-200 hover:text-amber-500">
                  <Phone className="h-4 w-4 text-amber-500" />
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a data-testid="footer-email-link" href={`mailto:${EMAIL_DISPLAY}`} className="flex items-center gap-2.5 transition-colors duration-200 hover:text-amber-500">
                  <Mail className="h-4 w-4 text-amber-500" />
                  {EMAIL_DISPLAY}
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <MapPin className="h-4 w-4 text-amber-500" />
                Deerfield Beach, FL 33441
              </li>
            </ul>
            <p className="font-mono-accent mt-6 text-[11px] uppercase tracking-[0.16em] text-slate-500">
              Mon–Sat 7:30 AM – 6:00 PM
              <br />
              Sun: Emergency Dispatch Only
            </p>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-7 text-xs text-slate-600 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} Atlantic Corridor Property Maintenance LLC. All rights reserved.</p>
          <p>Exclusive IP of Michael Caso / 305 KAOS PRODUCTIONS LTD.</p>
        </div>
      </div>
    </footer>
  );
}
